import React from 'react';
import Fb_icon from "../../images/Icons/fb-icon.svg";
import Ig_icon from "../../images/Icons/ig-icon.svg";
import Mail_icon from "../../images/Icons/mail-icon.svg";
import Megaphone from "../../images/Icons/megaphone.svg";
import UPC_exigete_innova from "../../images/Icons/UPC,exigete,innova.svg";
import WASC from "../../images/Icons/WASC.svg";
import '../../styles/footer.css';

const Footer = () => {
    return (
        <div className="footer">
            <div className="WASC">
                <a href="https://cultural.upc.edu.pe/" target="_blank" rel="noreferrer"><img alt="Senior College and University Commision" src={WASC}/></a>
            </div>
            <div className="icons">
                <a href="https://cultural.upc.edu.pe/" target="_blank" rel="noreferrer"><img alt="Icono de Facebook" src={Fb_icon}/></a>
                <a href="https://cultural.upc.edu.pe/" target="_blank" rel="noreferrer"><img alt="Icono de Instagram" src={Ig_icon}/></a>
                <a href="https://cultural.upc.edu.pe/" target="_blank" rel="noreferrer"><img alt="Icono de Mail" src={Mail_icon}/></a>
                <a href="https://cultural.upc.edu.pe/" target="_blank" rel="noreferrer"><img alt="Icono de Megafoon" src={Megaphone}/></a>
            </div>
            <div className="UPC">
                <a href="https://cultural.upc.edu.pe/" target="_blank" rel="noreferrer"><img alt="UPC" src={UPC_exigete_innova}/></a>
            </div>
        </div>
    )
}

export default Footer
